import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=324d307c&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d307c",
  null
  
)

export default component.exports